/* Uchi · cart upsell actions (swap / add / subscribe) inside the theme cart drawer. */
import { CartUpdateEvent } from '@theme/events';

const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const post = (url, body) =>
  fetch(`${root}${url}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  }).then(async (r) => {
    if (!r.ok) throw new Error((await r.json()).description || `Cart request failed (${r.status})`);
    return r.json();
  });

async function run(btn) {
  const { mode, line, qty, variant, plan } = btn.dataset;
  const quantity = Math.max(1, Number(qty) || 1);
  btn.setAttribute('aria-busy', 'true');
  try {
    if (mode === 'subscribe') {
      await post('cart/change.js', { id: line, quantity, selling_plan: Number(plan) });
    } else if (mode === 'swap') {
      // Add the upgrade first, then remove the original: if the add fails, nothing is lost.
      await post('cart/add.js', { items: [{ id: Number(variant), quantity }] });
      await post('cart/change.js', { id: line, quantity: 0 });
    } else {
      await post('cart/add.js', { items: [{ id: Number(variant), quantity: 1 }] });
    }
    const cart = await (await fetch(`${root}cart.js`)).json();
    document.dispatchEvent(new CartUpdateEvent(cart, 'uchi-upsell', { source: 'uchi-upsell', itemCount: cart.item_count }));
  } catch (err) {
    console.error('[uchi-upsell]', err);
    btn.removeAttribute('aria-busy');
    window.location.href = `${root}cart`;
  }
}

if (!window.__uchiUpsell) {
  window.__uchiUpsell = true;
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-uchi-upsell]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    run(btn);
  });
}
